import axios from 'axios';
// const API_URL = "http://localhost:3001";
const API_URL = "https://realplay.stickball.biz";




export const createSession = async (data) => {
    try {
        const res = await axios.post(`${API_URL}/api/sessions/create-with-dummy-user`, data);
        return res.data;
    } catch (error) {
        console.error('Error fetching notifications:', error);
        throw error;
    }
};

